module.exports = __webpack_public_path__ + "img/1.c01f6163.png";